<template>
  <!-- 产品与服务 -->
  <div class="safeContent">
    <headerPage  @changePage='changePage'></headerPage>
       <img  style="width:100%;margin-top:5px;" src="@/assets/img/ps_banner.png" alt='沁恒数联云盒' />
<!-- 数据云盒  --> 
     <div class="sysIntro">
      <div style="font-size:30px;margin-top:90px;display:inline-block">数 联 云 盒</div>
      <div style="color:#F4F3F4;margin-top:39px;">我们提供USB、串口、并口、网口四种不同类型的云盒来满足不同的应用需求</div>
      <div class="sysPart">
        <div
          class="common"
          v-for="(item,index) in firstData"
          :key="index"
          @mouseover="changImg(item,index)"
          @mouseleave='changImg(item,index)'
          :class="{active:index==current}" 
        >
        <!-- 1 -->
          <div v-if="!item.show" >
             <img  class="commonImg" :src='item.src' :alt='item.alt' />
             <div v-if="!item.show" style="margin-top:60px;font-size:20px;#F7FFFF;font-weight:bold">{{item.title}}</div>
             <div style="margin-top:25px;">{{item.note}}</div>
         </div>
         <!-- 2 -->
          <div v-else  style="background:#004B8F;height:100%;padding:0 25px;" >
             <img  style="margin-top:40px" :src='item.src' :alt='item.alt' />
             <div style="margin-top:20px;font-size:20px;#F7FFFF;font-weight:bold">{{item.title}}</div>
             <p style="line-height:30px;margin-top:27px;text-indent:2rem;text-align:left;">{{item.content}}</p>
             <img style="margin-top:40px;" :src='item.src2' :alt='item.alt'>
         </div>
        </div>
      </div>
    </div>
    
    <!-- 产品功能 -->
    <div class="protect">
           <div style="color:#4CAAF1;font-size:30px;margin-top:63px;display:inline-block;"><font class="block-border">产 品 功 能</font></div>
           <div style="margin-top:30px;margin-bottom:65px;">针对不同的需求场景，为客户提供“硬件+软件”的物联网行业网解决方案</div>
           <div style="width:1200px;display:flex;justify-content:space-between;margin:0 auto">
             <div style="width:299px;height:298px;background-color:#FFFFFF;"   v-for="(item,index) in proData" :key="index" >
               <div style="height:80px;width:100px;margin:80px auto;"   @animationend="endAni"  @mouseenter.self="showImg(item)">
                   <img  class="animated" style="margin-left:-8px;" :class="item.ani"  transitioned v-if="item.show"  :src="item.icon" :alt="item.alt">
               </div>
               <div style="font-size:25px;color:#707070;font-weight:bold;margin-top:-50px;">{{item.title}}</div>
              </div>
           </div>
    </div>
    <!-- 产品优势 -->
    <div class="advantage">
      <div style="margin-top:80px;display:inline-block;font-size:30px;"><font class="block-border">产 品 优 势</font></div>
      <div style="width:1200px;margin:30px auto;" >
         <div style="height:120px;display:flex;justify-content:space-between">
             <div @click="changeBanner(index)"  style="width: 203px;" :class="item.num==1?'':'activeAdv'" v-for="(item,index) in advData" :key="index">
              <img :src="item.num==1?item.src:item.src2" :alt="item.alt">
              <div>{{item.word}}</div>
           </div>
         </div>
       <el-carousel  arrow="always" :autoplay='false'  height='470px' @change='clickAdvBanner'  ref="carousel2"  indicator-position='none' >
        <el-carousel-item style="width: 100%;height: 470px;" v-for="(item,index) in advBanner" :key="index"  >
          <div style="width:1200px;position:relative;">
              <img  style="" class="secondImg" :src="item.icon" :alt="item.alt">
              <div style="position:absolute;left:120px;top:154px;width:378px;text-align:left;color:#646766;" >
                  <div style='font-size:20px;'>{{item.title}}</div>
                  <div style="margin-top:25px;">{{item.content}}</div>
              </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      </div>
    </div>

<!-- 系统服务  -->
    <div style="height:680px;position:relative">
             <img src="@/assets/img/service_jgbackground.png" style="position:absolute;margin-top:24px;z-index:-1;left:0" alt="">
            <div style="width:1200px;display:flex;justify-content:space-between;margin:0 auto;padding-top:120px;">
                 <div style="width:393px;margin-top:110px;color:white;text-align:left;text-indent:2rem;line-height:30px">
                   
                        <font style="font-size:30px;color:white">服 务 架 构</font>
                         <p style="margin-top:30px">沁恒第四代线下打印数据无感归集系统由线上数联慧通平台与线下数联云盒构成。</p>
                         <p style="margin-top:14px;">将打印机的小票数据实时汇集到云端，并进行图片还原、OCR识别、关键词提取等操作，输出各单明细内容。支持票据追加打印
                           、明细统计输出功能定制开发，为消费趋势预测、个性营销策划、会员系统开发等后续流程提供稳定可靠的大数据基础与平台接口，实现全维度消费信息
                           获取、多维度数据价值转换
                         </p>
                   </div> 
                   <img  src="@/assets/img/service_jiagou.png" style="margin-top:0;" alt="USB/串口/并口/网口">
           </div>
    </div>
    <!-- 处理流程 -->
    <div style="height:600px;background:#FFFF;padding-top:90px">
        <div style="color:#519AF1;font-size:30px;"><font class="block-border">服 务 流 程</font></div>  
         <div style="width:1200px;margin:30px auto;">
           <!-- 头 -->
               <div style="display:flex;width:1000px;overflow:hidden;margin:0px auto;">
                <div   v-for="(item,index) in processData" :key="index">
                  <div style="position:relative;width:200px;height:60px;display:flex;align-items:center;margin-left:20px;">
                            <img @click="changePro(index)" :src="item.num==1?item.src:item.src2" :alt='alt' />
                            <img style="margin-left:60px;" :src="item.icon" alt />
                  </div>
                  <div :class="index==currentIndex?'activeAdv':''"  style="width:100px;text-align:left;text-align:center;line-height:40px">{{item.word}}</div>
                </div>
              </div>
         </div>
         <div style="width:100%;background:#F4F7F6;">
           <div style="width:1200px;margin:-30px auto" >
             <el-carousel  :autoplay='false'   arrow="never" class="banner" height='400px' @change='changeProBanner'  ref="carousel"  indicator-position='none' >
               <el-carousel-item style="width: 1200px;height: 400px;" v-for="(item,index) in banner" :key="index"  >
                 <div style="width:900px;margin:100px auto;display:flex;justify-content: space-between;">
                    <div style="text-align:left;margin-top:20px;" >
                         <h4>{{item.title}}</h4>
                         <div>
                              <div style="color:#878787; line-height:32px; padding-top:20px;" v-html="item.content" ></div>
                         </div>
                     </div>
                     <img  style="width:200px;" :src="item.icon" :alt='alt'>
                 </div>
               </el-carousel-item>
             </el-carousel>
           </div>
         </div>
    </div>
    <!-- 系统优势 -->
    <div style="height:800px;">
       <div  style="margin-top:50px;font-size:30px;margin-bottom:70px;"><font class="block-border">服 务 优 势</font></div>
       <div style="width:1200px;margin:0 auto">
          <div   class="six">
            <div class="everyPart"   v-for="(item,index) in sixPartData" :key='index'  >
               <img style="position:absolute;z-index:-1;left:10px;top:0;width:280px;" class="showBox"  :src="item.src" :alt="item.alt">
               <img class="iconImg" :src="item.src2" :alt="item.alt">
                <div style="font-size:25px;margin-top:5px;">{{item.title}}</div>
                <div style="width:200px;margin:8px auto;"> {{item.detail}}</div>
            </div>
          </div>
          <div   class="six six2">
            <div class="everyPart" v-for="(item,index) in sixPartData2" :key='index'  >
               <img style="position:absolute;z-index:-1;left:10px;top:0;width:280px;" :src="item.src" :alt="item.alt">
               <img class="iconImg" :src="item.src2" :alt="item.alt">
                <div style="font-size:25px;margin-top:5px;">{{item.title}}</div>
                <div style="width:250px;margin:8px auto;"> {{item.detail}}</div>
            </div>
          </div>
       </div>
    </div>
    <!-- 底部 -->
     <footerPage style="width:100%;"></footerPage>
  </div>
</template>
<script>
import Vue from "vue";
import headerPage from "@/components/header.vue";
import footerPage from "@/components/footer.vue"
export default {
  components: {
    headerPage,
    footerPage
  },
  data() {
    return {
      firstData: [
      {alt:'USB型数联云盒',content:'实时归集串口微型打印机数据，通过有线/无线网络、4G等方式通讯并上传数据',src: require("@/assets/img/usb_white.png"),note:'WCH-UPDC-X',src2:require("@/assets/img/usb_box.png"),title:'USB型数联云盒', show: false },
      {alt:'串口型数联云盒',content:'实时归集串口微型打印机数据，通过有线/无线网络、4G等方式通讯并上传数据',src: require("@/assets/img/ck_white.png"), note:'WCH-SPDC-X',src2:require("@/assets/img/ck_box.png"),title:'串口型数联云盒',show:true },
      {alt:'并口型数联云盒',content:'实时归集串口微型打印机数据，通过有线/无线网络、4G等方式通讯并上传数据',src: require("@/assets/img/bk_white.png"), note:'WCH-LPDC-X',src2:require("@/assets/img/bk_box.png"),title:'并口型数联云盒',show: false },
      {alt:'网络型数联云盒',content:'实时归集串口微型打印机数据，通过有线/无线网络、4G等方式通讯并上传数据',src: require("@/assets/img/wk_white.png"), note:'WCH-NPDC-X',src2:require("@/assets/img/wk_box.png"),title:'网络型数联云盒',show: false }
    ],
    current:1,
    advData:[
         {alt: "无感化归集",num:1,word: "无感化归集",src: require("@/assets/img/advant_disable_01.png"),  src2: require("@/assets/img/advant_active_01.png")},
         {alt: "丰富传输接口",num:1,word: "丰富传输接口", src: require("@/assets/img/advant_disable_03.png"), src2: require("@/assets/img/advant_active_03.png")  },
         {alt: "兼容性高",num:1,word: "兼容性高",src: require("@/assets/img/advant_disable_04.png"), src2: require("@/assets/img/advant_active_04.png")},
         {alt: "归集准确", num:2,word: "归集准确", src: require("@/assets/img/advant_disable_05.png"), src2: require("@/assets/img/advant_active_05.png")  }, 
         {alt: "多种归集方式",num:1,word: "多种归集方式", src: require("@/assets/img/advant_disable_02.png"), src2: require("@/assets/img/advant_active_02.png")  }, 
    ],
    advBanner:[ 
              {alt: "无感化归集", icon: require("@/assets/img/youshi_wugan.png"),title:"无感化归集",content:'纯硬件归集，收银系统无需安装任何其它驱动或软件;只要将盒子串接在POS寄和原打印机制之间。'},
              {alt: "丰富传输接口",icon: require("@/assets/img/youshi_jkfh.png"),title:"丰富传输接口",content:'支持USB\串口\并口\网口实时上传归集到的打印机数据'},
              {alt: "兼容性高",icon: require("@/assets/img/youshi_jrx.png"),title:"兼容性高",content:'兼容市面上除A4纸通用打印机外的所有常见热敏、针式打印机。'},
              {alt: "归集准确",icon: require("@/assets/img/youshi_02.png"),title:"归集准确",content:'独有COLLECT-PASSTHROUGH技术，为复杂网络环境下数据归集保驾护航。'},
              {alt: "多种归集方式",icon: require("@/assets/img/youshi_01.png"),title:"多种归集方式",content:'先采后打、边采边打、无纸化打、追加打印满足所有数据操作需求。'},
            ],
     proData:[
        { alt:"无感归集",ani:"jackInTheBox",show:true, icon: require("@/assets/img/产品与服务-改(1)_47.png"),title:"无感归集"},
        { alt:"断网续存",ani:"jackInTheBox",show:true, icon: require("@/assets/img/产品与服务-改(1)_49.png"),title:"断网续存"},
        { alt:"二维码追打",ani:"jackInTheBox",show:true, icon: require("@/assets/img/产品与服务-改(1)_51.png"),title:"二维码追打"},
        { alt:"状态监控",ani:"jackInTheBox",show:true, icon: require("@/assets/img/产品与服务-改(1)_44.png"),title:"状态监控"},
     ],
   //   系统服务
    showPage:1, 
    sixPartData:[
      {alt:'归集准确',src: require("@/assets/img/six_icon2.png"), src2: require("@/assets/img/s_icon1.png"),title:'归集准确',detail:'沁恒独有的CPT技术'},
      {alt:'兼容性高',src: require("@/assets/img/six_icon1.png"), src2: require("@/assets/img/s_icon2.png"),title:'兼容性高',detail:'支持各种常见品牌的小票打印机'},
      {alt:'即装即采',src: require("@/assets/img/six_icon2.png"), src2: require("@/assets/img/s_icon3.png"),title:'即装即采',detail:'配置简单，外置配属不改变原有打印设置'},
      {alt:'数据安全',src: require("@/assets/img/six_icon1.png"), src2: require("@/assets/img/s_icon4.png"),title:'数据安全',detail:'支持设备连接安全认证和数据加密传输'},
    ],
     sixPartData2:[
      {alt:'远程云端管理',src: require("@/assets/img/six_icon2.png"), src2: require("@/assets/img/s_icon5.png"),title:'远程云端管理',detail:'远程数据分析处理、云端管理、状态实时查询'},
      {alt:'开发投入少',src: require("@/assets/img/six_icon1.png"), src2: require("@/assets/img/s_icon6.png"),title:'开发投入少',detail:'可根据需求进行产品定制，提供二次开发SDK'},
      {alt:'网络汇集',src: require("@/assets/img/six_icon2.png"), src2: require("@/assets/img/s_icon7.png"),title:'网络汇集',detail:'支持以太网 /WIFI/2G/4G/USB传输接口和断点续传'},
   
    ],
     proImg1: require("@/assets/img/process_row_disable.png"),
     proImg2: require("@/assets/img/process_row_active.png"),
     processData: [
        {alt: "数据归集",num:2, word: "数据归集",src: require("@/assets/img/workflow_disable_01.png"),src2: require("@/assets/img/workflow_active_01.png"),  icon: require("@/assets/img/process_row_disable.png")},
        {alt: "图片还原",num:1, word: "图片还原", src: require("@/assets/img/workflow_disable_02.png"),src2: require("@/assets/img/workflow_active_02.png"), icon: require("@/assets/img/process_row_disable.png")  },
        {alt: "字符识别",num:1, word: "字符识别", src: require("@/assets/img/workflow_disable_03.png"),src2: require("@/assets/img/workflow_active_03.png"),icon: require("@/assets/img/process_row_disable.png") },  
        {alt: "文字提取",num:1, word: "文字提取",src: require("@/assets/img/workflow_disable_04.png"),src2: require("@/assets/img/workflow_active_04.png"), icon: require("@/assets/img/process_row_disable.png")}, 
        {alt: "统计汇总",num:1, word: "统计汇总", src: require("@/assets/img/workflow_disable_05.png") ,src2: require("@/assets/img/workflow_active_05.png"),}
      ],
       banner:[ 
              { alt:"数据归集",icon: require("@/assets/img/fw_sjgj.png"),title:"数据归集",content:'通过私有加密协议将数联云盒采集的打印机数据传输到云端,<br/>服务将数据以文件形式归档保存。'},
              { alt:"图片还原",icon: require("@/assets/img/fw_tphy.png"),title:"图片还原",content:'通过我们的独有算法将数联云盒归集到的光栅格式打印数据，还原成与<br/>原始打印内容排版相近的图片文件。'},
              { alt:"字符识别",icon: require("@/assets/img/fw_zfsb.png"),title:"字符识别",content:'使用平台内置的OCR还原系统将图片上的文字准确识别成文本格式。'},
              { alt:"文字提取",icon: require("@/assets/img/fw_wztq.png"),title:"文字提取",content:'通过配置小票模型，快速转却提取小票文本内容的金额、明细、单号、<br/>购买时间等相关信息。'},
              { alt:"统计汇总",icon: require("@/assets/img/fw_tjsc.png"),title:"统计汇总",content:'将精准提取的小票数据统计汇总输出，支持数据接口输出、统计报表<br/>输出、图形可视化分析汇总输出。'},
              ],
      flag:false,
      currentIndex:0,
   };
  },
  methods: {

   changImg(item,index){
       this.current=index
      this.firstData.forEach((item,index)=>{
         if(index==this.current){
            item.show=true
         }else{
           item.show=false
         }
      })
   },
   changeBanner(index){
      this.$refs.carousel2.activeIndex=index
      this.advData.forEach((item,i)=>{       
         if(i==index){
           item.num=2 
         }else{
           item.num=1
         }
      })
   },
   clickAdvBanner(){
      this.changeBanner(this.$refs.carousel2.activeIndex)
   },
   changePage(num){
     this.showPage=num
   },
  //  合作流程
     changePro(index) {
       this.currentIndex=index
      this.$refs.carousel.activeIndex=index
      this.processData.forEach((item, i) => {
        item.num=i<=index?2:1
        item.icon=i<index?this.proImg2:this.proImg1
      })
    },
    changeProBanner(){
      this.changePro(this.$refs.carousel.activeIndex)
    },
    showImg(item,event){
       this.flag=false
        item.show=false
        setTimeout(() => {
          item.show=true
        }, 16.9);
    },
      endAni(){
          this.flag=true
    },
  },
  
};
</script>
<style scoped  lang='scss'>
.acitveColor{
color: #49A0F8
}
.headerContent {
  width: 100%;
  height: 590px;
  background: #f5f5f5;
  margin: 4px auto;
}
.sysIntro {
  width: 100%;
  margin: 0 auto;
  height: 700px;
  background: #3487d0;
  color: #fcffff;
}
.sysPart {
  width: 1200px;
  height: 420px;
  margin: 95px auto;
  display: flex;
  justify-content: space-between;
}
.common {
  width: 276px;
  height: 390px;
  background: #0167c6;
  text-align: center;
  margin-top:25px;
  overflow:hidden
}
.commonImg{
   margin-top:122px;
}

.active{
  /* animation: bigImg 0.1s ease  forwards; */
    width:352px;
    height: 450px;
    margin-top:-36px;
}
@keyframes bigImg{
  to{
    width:352px;
    height: 414px;
    margin-top:0;
  }
}
/* 优势 */
.advantage {
  width: 100%;
  background: #ffffff;
  margin: 0 auto;
}
.activeAdv{
   border-bottom: 4px solid #3888D8;
}
.advCommon{
    border-bottom: 4px solid white;
}
.protect {
  width: 100%;
  height: 605px;
  background: #f4f7f6;
  margin: 0 auto;
}
.bigWord {
  font-size: 30px;
  color: white;
}
.smallWord {
  font-size: 16px;
  color: white;
}
.firstImg{
   position:absolute;
   top:0;
   left:0;
   bottom:0;
}
.secondImg{
  position:absolute;
   right:80px;
   /* bottom:20px; */
   top: 100px;
}
/* 系统服务 */
.six{
   display: flex;
   justify-content: space-around;
}
.six2{
  width: 900px;
  margin:-70px auto;
}
.everyPart{
  margin-top:20px;
  position:relative;
  width:370px;
  height: 300px;
//  -webkit-clip-path: polygon(47.5% 5.66987%, 48.2899% 5.30154%, 49.13176% 5.07596%, 50% 5%, 50.86824% 5.07596%, 51.7101% 5.30154%, 52.5% 5.66987%, 87.14102% 25.66987%,
//   87.85495% 26.16978%, 88.47124% 26.78606%, 88.97114% 27.5%, 89.33948% 28.2899%, 89.56505% 29.13176%, 89.64102% 30%, 89.64102% 70%, 89.56505% 70.86824%, 89.33948% 71.7101%,
//    88.97114% 72.5%, 88.47124% 73.21394%, 87.85495% 73.83022%, 87.14102% 74.33013%, 52.5% 94.33013%, 51.7101% 94.69846%, 50.86824% 94.92404%, 50% 95%, 49.13176% 94.92404%, 
//    48.2899% 94.69846%, 47.5% 94.33013%, 12.85898% 74.33013%, 12.14505% 73.83022%, 11.52876% 73.21394%, 11.02886% 72.5%, 10.66052% 71.7101%, 10.43495% 70.86824%, 10.35898% 70%, 
//    10.35898% 30%, 10.43495% 29.13176%, 10.66052% 28.2899%, 11.02886% 27.5%, 11.52876% 26.78606%, 12.14505% 26.16978%, 12.85898% 25.66987%);
}


.iconImg{
  width: 112px;
  margin: 40px  auto;
  display: inline-block;
}
.block-border{
  font-size:30px;
  font-weight: bold;
  color:#0158a7;
  border-bottom:2px solid #0158a7;
}
</style>
<style  lang='scss'>
.el-carousel__item  {
background: #F5F8FA
}
.headerContent{
  .el-carousel__button{
       background-color: rgb(250, 202, 112)!important
  }
}
</style>


// WEBPACK FOOTER //
// src/view/service.vue